import { VMModule, VMContentItem } from '../vm_models';

export class VeiligheidsMeter {
  vmID: string;
  vmReady: boolean;
  currentVMModule: string;
  currentVMTip: string;
  vmModuleKeys: string[];
  vmModules: VMModule[]; 
  vmContentItems: Array<VMContentItem>;
}
